<template>
  <div>
    <h2 class="label mb10">{{locale.admin_codelist}}</h2>
    <div class="add">
      <select class="input select" v-model="codeType">
        <option
          v-for="code in codeTypes"
          :key="code.id"
          :value="code.id">
          {{ code.label }}
        </option>
      </select>
      <input type="text" class="input"
        v-model="newCode"
        @keyup.enter="setCategory" />
      <button type="submit" class="btn"
        :class="{'btnGrey disabled': isExist}"
        :disabled="isExist"
        @click="setCategory">
        {{locale.add}}
      </button>
    </div>
    <p v-if="isExist" class="colorRed mt5">{{locale.admin_code_exist}}</p>
    <table class="table mt15">
      <tbody>
        <tr v-for="code in codeList" :key="code.id">
          <Item
            :locale="locale"
            :code="code"
            :existCode="existCode"
            @checkExist="checkModify"
            @delItem="deleteItem" />
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btnFull btnPrimary mt15"
      :class="{
        btnPrimary: existCode.length === 0,
        'btnGrey disabled': existCode.length > 0
      }"
      :disabled="existCode.length > 0"
      @click="setCategory('update')">
      {{locale.save}}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import Item from '@/components/Admin/CodeItem.vue'

export default {
  name: 'Code',
  props: [
    'locale'
  ],
  components: {
    Item
  },
  computed: {
    ...mapGetters({
      getCode: 'admin/codeList'
    }),
    codeList: {
      get () {
        return this.getCode
      },
      set (list) {
        const systemCodes = this.codeList.filter(x => x.type === 'system').map(c => {
          return c.id
        })
        const userCodes = list.filter(x => (x.type === 'user' || x.type === 'SHOP_ITEM_TYPE') && !systemCodes.includes(x.id))
        this.$store.dispatch('admin/setCode', userCodes).then(() => {
          alert(this.locale.complete_delete)
          this.init()
        })
      }
    },
    labelList () {
      return this.codeList.map(x => x.label)
    },
    isExist () {
      const list = this.labelList
      return list.includes(this.newCode)
    },
    existCode () {
      const codeList = this.codeList
      const existFilter = codeList.filter((x, index) => codeList.findIndex(c => x.label === c.label) !== index).map(x => x.label)
      return existFilter
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      newCode: '',
      codeType: 'user',
      codeTypes: [
        {
          id: 'user',
          label: this.locale.submit
        },
        {
          id: 'SHOP_ITEM_TYPE',
          label: 'shop'
        }
      ],
      modify: true
    }
  },
  methods: {
    init () {
      this.newCode = ''
      this.$store.dispatch('admin/getCodes')
    },
    exist (cate) {
      return cate === this.newCode
    },
    checkModify (state) {
      this.modify = state
    },
    setCategory (update) {
      const isUpdate = update === 'update'
      const addData = {
        id: UNIQUE.mid(),
        label: this.newCode,
        type: this.codeType
      }
      const systemCodes = this.codeList.filter(x => x.type === 'system').map(c => c.id)
      const userCodes = this.codeList.filter(x => x.type !== 'system' && !systemCodes.includes(x.id))
      const data = isUpdate ? userCodes : userCodes.concat([addData])
      if (!this.isExist && window.confirm(this.locale.confirm_save_code)) {
        this.$store.dispatch('admin/setCode', data).then(() => {
          alert(this.locale.complete_save)
          this.init()
        })
      }
    },
    deleteItem (data) {
      this.codeList = this.codeList.filter(x => x.id !== data.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  display: flex;
  .input {
    margin-right: 4px;
  }
  .select {
    flex: none;
    width: auto;
  }
}
.btn.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
